const getSocialButtonStyle = () =>
  "bg-muted text-foreground border border-border gap-2";

export default getSocialButtonStyle;
